import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6e2ihyb9: FaireBrandEntity = {
  token: "b_6e2ihyb9",
  type: "brand",
  name: "Seas and Peas, LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/a591aafedcb5525dce1f13db8c6bd7dc22ab2bc6f7adc57e2ceb4ff7fa501ac3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7922adba4b87b02f1b919e75b24cf81414205ffd03dd3d8f6830a8ff3266050f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a591aafedcb5525dce1f13db8c6bd7dc22ab2bc6f7adc57e2ceb4ff7fa501ac3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7922adba4b87b02f1b919e75b24cf81414205ffd03dd3d8f6830a8ff3266050f.png",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Seas and Peas is creative collaboration between partners Chad and Claudio. Based in Seattle, WA, USA, we create fun handmade greeting cards on 100% recycled cardstock.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:39.139Z",
    importedBy: "entity-db-cli",
  },
};
